import moment from 'moment';

import { ALL_LOCATIONS } from './constants';
import { shortDate, shortMonthAndDate } from '../../../utils/Date';
import { mapEducations } from '../../shortlistedWeployees/SelectionScreen/mappers';


const hasStarted = position => moment().isSameOrAfter(position.startDate);
const getYear = date => moment(date).format('YYYY');
const dayAfter = date => moment(date).add(1, 'day');

// Ensure we only ever return first to initials max
export const stripInitials = initials => initials.replace(/\s+/g, '').slice(0, 2);

export const weployeeDetails = (details) => {
  const {
    certifications,
    educations,
    endorsedSkills,
    initials,
    systemKnowledges,
    technicalSkills,
    userId,
    weployExperiences,
    workExperiences,
  } = details;

  const result = {
    certifications: certifications.map(certification => ({ ...certification, id: `${certification.name}-${certification.issueDate}` })),
    educations: mapEducations(educations),
    endorsedSkills,
    id: userId,
    initials: stripInitials(initials),
    systemsKnowledges: systemKnowledges,
    technicalSkills,
    weployExperiences,
    workExperiences,
  };

  return result;
};

export const availabilitySchedule = (positions) => {
  if (positions.length >= 2) {
    const orderedPositions = positions.sort((positionA, positionB) => moment(positionB.finishDate) - moment(positionA.finishDate));
    const latestFinishDate = orderedPositions[0].finishDate;
    return `Available from ${shortDate(dayAfter(latestFinishDate))}`;
  } else if (positions.length === 1) {
    const position = positions[0];
    if (hasStarted(positions[0])) {
      return `Available from ${shortDate(dayAfter(position.finishDate))}`;
    }
    return `Available until ${shortDate(position.startDate)}`;
  }
  return 'Open to opportunies';
};

export const workExperiences = (experiences) => {
  const sortedWorkExperiences = experiences.sort((workExperienceA, workExperienceB) => (
    moment(workExperienceB.startDate) - moment(workExperienceA.startDate)
  ));

  return sortedWorkExperiences.map(({ title, startDate, endDate }, index) => {
    if (index === 0) {
      return `${title} • ${shortMonthAndDate(startDate)} - ${endDate ? shortMonthAndDate(endDate) : 'present'}`;
    }
    return `${title} • ${getYear(startDate)} - ${endDate ? getYear(endDate) : 'present'}`;
  });
};

export const availabilities = (availabilitiesList) => {
  const mappedAvailabilities = availabilitiesList.sort().join(' / ');
  return mappedAvailabilities.charAt(0).toUpperCase() + mappedAvailabilities.slice(1);
};

export const mapLocation = (location) => {
  if (location === ALL_LOCATIONS) {
    return null;
  }
  return location;
};
